import React, { Component } from "react";
import API from "../../apiService.js";
import ReactToPrint from "react-to-print";
import Select2 from "react-select";
import LabPrint from "../lab/LabPrint.js";
import Alert from "../component/Alert";
import moment from "moment";
import AlertWithButton from "../component/Alert";
import DatePickerX from "./DatePicker.js";
import ModalDetail from "./ModalDetail";
import apiService from "../../apiService.js";
import ModalAddBiling from "view/payments/ModalAddBiling.js";
import { array } from "yup";
import { A } from "react-select/dist/index-fa0d9f94.esm.js";

export default class PemeriksaanLab extends Component {
  constructor(props) {
    super(props);
    let d = new Date();
    this.state = {
      labs: [],
      lab: [],
      lab_groups: [],
      lab_categories: [],
      selectedOption: [],
      options: [],
      valueoptions: [],
      user: {
        name: "",
        nip: "",
      },
      detail: [],
      button: true,
      patients: this.props.detilPx,
      sample: [],
      samples: [],
      profile: {
        villages: null,
      },
      receive_date: this.props.detilPx.labs[0]?.receive_date
        ? new Date(this.props.detilPx.labs[0]?.receive_date)
        : "",
      handover_date: this.props.detilPx.labs[0]?.handover_date
        ? new Date(this.props.detilPx.labs[0]?.handover_date)
        : "",
      is_ranap: window.location.pathname.includes("ranap"),
      inpatient: props.detilPx.inpatient ?? null,
      all_datas: [],
      data_index: 0,
      showModalDetail: false,
      labDetail: null,
      registration_lab: null,
      visit: null,
      modalAddBiling: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.addChange = this.addChange.bind(this);
    this.removeChange = this.removeChange.bind(this);
    this.logChange = this.logChange.bind(this);
  }

  componentDidMount() {
    this.getServing();
    this.getVisit();
  }
  onReload = () => {
    this.props.history.push("/pelayanan");
  };

  handleChange = (e) => {
    // this.setState(prevState => ({
    //   detail: prevState.detail.map(
    //     obj => (
    //       obj.id === e.target.value ? Object.assign(obj, { checked: true }) : obj
    //     )
    //   )
    // }));
    var k = this.state.detail;
    var j = [];
    if (k[e.target.id].checked) {
      k[e.target.id].checked = false;
      this.state.lab.map((x, n) => {
        j[n] = x;
        if (k[e.target.id].lab_group_id === x.id) {
          j[n].checked = false;
        }
      });
      this.setState({
        lab: j,
      });
    } else k[e.target.id].checked = true;

    k[e.target.id].result = e.target.value;
    this.setState({
      detail: k,
    });
  };

  logChange = (val) => {
    let gh = [];
    let g = [];
    if (val) {
      val.map((x, k) => {
        g[k] = x.value;
        gh[k] = x.label;
      });
    }

    this.setState({
      samples: gh,
      sample: g,
      valueoptions: val,
    });
  };

  async getVisit() {
    const r = await apiService.post(`registration`, {
      keyword: {
        visitId: this.props.detilPx.id,
        name: "",
        nik: "",
        bod: "",
        noRm: "",
        clinicId: "",
      },
      limit: 1,
      // "served": 1,
    });
    if (r.code === 200 && r.data.data.length) {
      this.setState({ visit: r.data.data[0] });
    }
  }

  async removeChange(e) {
    var d = [];
    var id = null;
    this.state.detail.map((x, n) => {
      d[n] = x;
      if (d[n].lab_id == e.target.value) {
        id = d[n].registration_id;
        d[n].hidden = true;
        d[n].checked = false;
        d[n].isDisabled = false;
      }
    });

    this.setState({
      detail: d,
    });

    if (id) await API.delete("registration/lab/delete/" + id);
  }

  addChange = (val) => {
    var d = [];
    this.state.detail.map((x, n) => {
      d[n] = x;
      if (d[n].lab_id === val.value) {
        d[n].hidden = false;
        d[n].checked = true;
        d[n].isDisabled = true;
        d[n]._cat = d[n].cat;
        this.setState({
          labs: [...this.state.labs, d[n]],
        });
      }
    });
    this.setState({
      detail: d,
    });
  };

  getServing = async () => {
    try {
      var res = await API.get(
        `registration/lab/read?visit_id=${this.props.detilPx.id}&is_ranap=${this.state.is_ranap}`
      );
      if (res.code === 200) {
        this.setState({
          labs: res.data[res.data.length - 1].details,
          user: res.data[res.data.length - 1].user,
          sample: res.data[res.data.length - 1].sample.split(","),
          data_index: res.data.length - 1,
          all_datas: res.data,
          registration_lab: res.data[res.data.length - 1],
        });
      }
    } catch (error) {}
    try {
      var dod = await API.get(
        "management/profiles/read?code=" +
          JSON.parse(localStorage.getItem("userData")).puskesmas_id
      );
      var d = new Date();
      if (dod.code === 200) {
        this.setState({
          profile: dod.data,
        });
      }
    } catch (error) {}
    try {
      var res4 = await API.get(
        "management/lab_category/search/" + this.state.sample.toString()
      );
      let fs = [];
      if (res4.code === 200) {
        res4.data.map((x, k) => {
          fs[k] = x.name;
        });

        this.setState({
          samples: fs,
        });
      }
    } catch (error) {
      console.log(error);
    }
    try {
      var res2 = await API.get("management/lab_group/read");
      if (res2.code === 200) {
        this.setState({
          lab_groups: res2,
        });
      }
    } catch (error) {
      console.log(error);
    }
    try {
      var res3 = await API.get("management/lab_category/read");
      if (res3.code === 200) {
        this.setState({
          lab_categories: res3,
        });
      }
    } catch (error) {
      console.log(error);
    }

    this.onIndexChange(null, res.data.length - 1);
  };

  onIndexChange = (labs = null, index = 0) => {
    this.setState({
      receive_date: this.state.all_datas[index].receive_date
        ? new Date(this.state.all_datas[index].receive_date)
        : "",
      handover_date: this.state.all_datas[index].handover_date
        ? new Date(this.state.all_datas[index].handover_date)
        : "",
    });

    try {
      let group = [];
      let lab = [];
      let d = 0;
      this.state.lab_groups.data.map((x, n) => {
        group[n] = x;

        x.details.map((detail) => {
          lab[d] = detail;
          let h = (labs ?? this.state.labs).find(
            (set) =>
              !set.log &&
              set.lab_id === detail.lab_id &&
              set.cat == detail.lab_group_id
          );
          if (h) {
            lab[d].registration_id = h.id;
            lab[d].result = h.result;
            lab[d].cat = h.cat;
            lab[d].checked = true;
            lab[d].hidden = false;
            lab[d].isDisabled = true;
            lab[d].user = h.user.name;
            lab[d].date = h.updated_at;
          } else {
            lab[d].registration_id = null;
            lab[d].result = "";
            lab[d].cat = x.id;
            lab[d].checked = false;
            lab[d].hidden = true;
            lab[d].isDisabled = false;
            lab[d].user = "-";
            lab[d].date = "";
          }
          lab[d].value = detail.lab ? detail.lab.id : "";
          lab[d].label = detail.lab ? x.name + " | " + detail.lab.name : "";

          lab[d].group_id = x.id;
          d++;
        });
      });

      this.setState({
        lab: group,
        detail: lab,
      });
    } catch (e) {
      console.log(e);
    }

    try {
      let m = [];
      let n = [];
      this.state.lab_categories.data.map((x, k) => {
        m[k] = x;
        m[k].value = x.id;
        m[k].key = k;
        m[k].label = x.name;

        let h = this.state.sample.find((s) => s == x.id);
        if (h) {
          n[k] = x;
          n[k].value = x.id;
          n[k].key = k;
          n[k].label = x.name;
        }
      });
      this.setState({
        options: m,
        valueoptions: n,
      });
    } catch (e) {
      console.log(e);
    }
  };

  handleSend = async () => {
    this.setState({ button: false });
    var k = [];
    var i = 0;
    this.state.detail.map((x) => {
      if (!x.hidden) {
        k[i] = x;

        k[i].id = x.registration_id;
        k[i].hidden = false;

        if (
          this.state.lab.find((set) => set.checked && set.id === x.lab_group_id)
        )
          k[i].lab_group_id = x.lab_group_id;
        else k[i].lab_group_id = null;
        i++;
      }
    });

    const res = await API.put("registration/lab/update", {
      lab: [
        {
          id: this.state.labs[0] ? this.state.labs[0].registration_lab_id : "",
          serve: true,
          visit_id: this.props.detilPx.id,
          visit_inpatient_clinic_id: this.state.is_ranap
            ? this.state.inpatient.id
            : null,
          sample: this.state.sample.toString(),
          details: k,
          receive_date: this.state.receive_date
            ? moment(this.state.receive_date).format("YYYY-MM-DD HH:mm:ss")
            : null,
          handover_date: this.state.handover_date
            ? moment(this.state.handover_date).format("YYYY-MM-DD HH:mm:ss")
            : null,
        },
      ],
    });
    if (res.code === 200) {
      Alert("success", "Sukses menyimpan data pemeriksaan lab pasien");

      this.getServing();
      await API.post("pcare/mcu/" + this.props.detilPx.id);
    } else {
      AlertWithButton(
        "warning",
        "Gagal menyimpan data pemeriksaan lab pasien\nPeriksa kembali isian data anda"
      );
    }
    this.setState({ button: true });
  };

  openDetail(lab) {
    this.setState({
      labDetail: lab,
      showModalDetail: true,
    });
  }

  render() {
    let d = new Date();
    let color = this.state.labs.find((set) => set.log) ? "#5e72e4" : "";
    // console.log(this.state);
    const log = this.state.labs.map((labs, keys) => {
      return labs.log ? (
        <li
          className="checklist-entry list-group-item align-items-start"
          key={keys}
        >
          <div className="d-flex w-100 justify-content-between">
            <div>
              <div className="d-flex w-100 align-items-center">
                <h3 className="mb-1">{labs.user.name}</h3>
              </div>
            </div>
            <small>
              {moment(labs.created_at).format("DD-MM-YYYY HH:mm:ss")}
            </small>
          </div>
          <div className="row h4">
            <div className="col-4">Pemeriksaan</div>
            <div className="col-8">
              : <mark>{labs.lab.name}</mark>
            </div>
            <div className="col-4">Hasil</div>
            <div className="col-8">
              :{" "}
              <mark>
                {labs.result ? labs.result + " " + labs.lab.unit : "-"}
              </mark>
            </div>
          </div>
        </li>
      ) : (
        ""
      );
    });
    return (
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <div className="row align-items-center">
                <h4 className="h3 mb-0">Pemeriksaan Laboratorium</h4>
                <button
                  onClick={() =>
                    this.setState({
                      modalAddBiling: !this.state.modalAddBiling,
                    })
                  }
                  className=" ml-4 btn btn-secondary"
                >
                  Tambahkan Biling untuk lab (lab berbayar)
                </button>
              </div>
            </div>
            {this.state.modalAddBiling ? (
              <ModalAddBiling
                show={this.state.modalAddBiling}
                onHide={() => this.setState({ modalAddBiling: false })}
                close={() => this.setState({ modalAddBiling: false })}
                data={this.props.detilPx}
              />
            ) : (
              ""
            )}
            {this.state.is_ranap && (
              <div className="card-body">
                {this.state.all_datas.map((v, k) => (
                  <button
                    key={k}
                    style={{ marginTop: 8 }}
                    onClick={() => {
                      this.setState({
                        data_index: k,
                        labs: this.state.all_datas[k].details,
                      });
                      this.onIndexChange(this.state.all_datas[k].details, k);
                    }}
                    className={
                      this.state.all_datas[this.state.data_index].created_at ===
                      v.created_at
                        ? "btn btn-primary"
                        : "btn"
                    }
                  >
                    {moment(v.created_at).format("L LTS")}
                  </button>
                ))}
              </div>
            )}
            <div className="card-body">
              <div className="row">
                <div className="col-12">
                  {this.state.visit && (
                    <div
                      className={"bg-primary text-primary mb-3 p-4"}
                      style={{ borderRadius: 4 }}
                    >
                      <label className="h4 text-white mb-0">
                        Dokter: {this.state.visit.paramedic?.name ?? ""}
                      </label>
                      <br />
                      <label className="h4 text-white mb-0">
                        Diagnosa:{" "}
                        {this.state.visit.diagnoses
                          ?.map((v) => `${v.icd_code} - ${v.icd_name}`)
                          .join(", ")}
                      </label>
                    </div>
                  )}
                  <div className="list-group-item bg-primary text-primary">
                    <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <label className="h4 text-white">JENIS SAMPEL</label>
                          <Select2
                            isMulti={true}
                            value={this.state.valueoptions}
                            options={this.state.options}
                            onChange={this.logChange}
                            placeholder="Pilih jenis sampel"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="text-white col-md-6">
                            Sampel diterima
                          </label>
                          {/* <input className="form-control" placeholder="sampel Diterima" type="datetime" value={moment(this.state.receive_date).format('YYYY-MM-DD hh:mm:ss')} onChange={(e)=> this.setState({receive_date: e.target.value})} /> */}
                          <DatePickerX
                            class="form-control col-md-12"
                            startDate={this.state.receive_date}
                            setStartDate={(e) =>
                              this.setState({ receive_date: e })
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          {/* <div className="row"> */}
                          <label className="text-white col-md-6">
                            Selesai dianalisis
                          </label>
                          <DatePickerX
                            class="form-control col-md-12"
                            startDate={this.state.handover_date}
                            setStartDate={(e) =>
                              this.setState({ handover_date: e })
                            }
                          />
                          {/* </div> */}
                          {/* <input className="form-control" placeholder="sampel selesai analisis" type="datetime" value={this.state.handover_date} onChange={(e) => this.setState({ handover_date: e.target.value })} /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <div className="row">
                    <div className="col-12">
                      <div className="list-group-item bg-primary text-primary">
                        <div className="row">
                          <div className="col-12">
                            <div className="form-group">
                              <label className="h4 text-white">
                                PERMINTAAN PEMERIKSAAN
                              </label>
                              <Select2
                                options={this.state.detail}
                                onChange={this.addChange}
                                placeholder="Pilih jenis pemeriksaan lab"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <div className="accordion" id="accordionlab">
                    {this.state.lab.map((lab, keys) => {
                      let permintaan_ = this.state.labs;
                      let color = this.state.detail.find(
                        (set) => !set.hidden && set.group_id == lab.id
                      )
                        ? "#5e72e4"
                        : "";

                      let show = this.state.detail.find(
                        (set) =>
                          !set.hidden &&
                          set.group_id == lab.id &&
                          permintaan_.some((a) => a.cat == lab.id)
                      )
                        ? true
                        : false;
                      if (show) {
                        return (
                          <div key={keys} className="card">
                            <div
                              className="card-header collapsed"
                              id={"headinglab" + lab.id}
                              data-toggle="collapse"
                              data-target={"#collapselab" + lab.id}
                              aria-expanded="false"
                              aria-controls={"collapselab" + lab.id}
                            >
                              <div style={{ color: color }} className="h4">
                                {lab.name.toUpperCase() + " "}
                              </div>
                            </div>
                            <div
                              className="collapse"
                              id={"collapselab" + lab.id}
                              aria-labelledby={"headinglab" + lab.id}
                            >
                              <div className="card-body">
                                <div className="row">
                                  {this.state.detail.map((detail, key) => {
                                    return detail.group_id == lab.id ? (
                                      <div
                                        key={key}
                                        hidden={detail.hidden}
                                        className="col-md-6"
                                      >
                                        <div className="form-group">
                                          <div className="row">
                                            <div className="col-md-8">
                                              {detail.lab
                                                ? detail.lab.name + " "
                                                : ""}
                                            </div>
                                            <div className="col-md-4 text-right"></div>
                                          </div>
                                          <div className="input-group">
                                            <button
                                              type="button"
                                              className="btn btn-outline-default btn-sm"
                                              data-toggle="dropdown"
                                              aria-haspopup="true"
                                              aria-expanded="false"
                                            >
                                              ?
                                            </button>
                                            <div className="dropdown-menu col-12">
                                              <div className="dropdown-item">
                                                <div
                                                  style={{
                                                    whiteSpace: "normal",
                                                  }}
                                                  className="list-group-item"
                                                >
                                                  <h5>Nilai Minimal:</h5>
                                                  <mark>
                                                    {detail.lab
                                                      ? detail.lab.min_value
                                                      : ""}
                                                  </mark>
                                                </div>
                                                <div
                                                  style={{
                                                    whiteSpace: "normal",
                                                  }}
                                                  className="list-group-item"
                                                >
                                                  <h5>Nilai Maksimal:</h5>
                                                  <mark>
                                                    {detail.lab
                                                      ? detail.lab.max_value
                                                      : ""}
                                                  </mark>
                                                </div>
                                                <div
                                                  style={{
                                                    whiteSpace: "normal",
                                                  }}
                                                  className="list-group-item"
                                                >
                                                  <h5>Nilai Normal:</h5>
                                                  <mark>
                                                    {detail.lab
                                                      ? detail.lab.normal_value
                                                      : ""}
                                                  </mark>
                                                </div>
                                                <div
                                                  style={{
                                                    whiteSpace: "normal",
                                                  }}
                                                  className="list-group-item"
                                                >
                                                  <h5>
                                                    Pembaharuan Data Terakhir:
                                                  </h5>
                                                  <div className="d-flex w-100 justify-content-between">
                                                    <div>
                                                      <div className="d-flex w-100 align-items-center">
                                                        <mark>
                                                          {detail.user}
                                                        </mark>
                                                      </div>
                                                    </div>
                                                    <small>
                                                      {detail.date
                                                        ? moment(
                                                            detail.date
                                                          ).format(
                                                            "DD-MM-YYYY HH:mm:ss"
                                                          )
                                                        : "-"}
                                                    </small>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <button
                                              type="button"
                                              className="btn btn-outline-warning btn-sm"
                                              style={{ marginRight: 4 }}
                                              onClick={() =>
                                                this.openDetail(detail.lab)
                                              }
                                            >
                                              <i className={"fa fa-eye"} />
                                            </button>
                                            <input
                                              className="form-control"
                                              style={{ float: "right" }}
                                              name={
                                                "chk-lab-detail" +
                                                detail.group_id
                                              }
                                              type={
                                                detail.lab
                                                  ? detail.lab.value_type ==
                                                    "angka"
                                                    ? "number"
                                                    : "text"
                                                  : "text"
                                              }
                                              value={detail.result}
                                              id={key}
                                              onChange={this.handleChange}
                                            />
                                            <div className="input-group-append">
                                              <span
                                                className="input-group-text"
                                                id="basic-addon2"
                                              >
                                                {detail.lab
                                                  ? detail.lab.unit
                                                  : ""}
                                              </span>
                                            </div>
                                            <button
                                              type="button"
                                              value={detail.lab_id}
                                              onClick={this.removeChange}
                                              className="btn btn-danger btn-sm"
                                            >
                                              -
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>
              <div className="collapse" id="collapsePreview">
                <br></br>
                <div className="list-group-item" style={{ display: "block" }}>
                  <LabPrint
                    ref={(el) => (this.componentRef = el)}
                    detilPx={this.state.patients}
                    labs={this.state.labs}
                    lab={this.state.lab}
                    samples={this.state.samples}
                    user={this.state.user}
                    profile={this.state.profile}
                    sample={this.state.sample}
                    registration_lab={this.state.registration_lab}
                  />
                </div>
              </div>
            </div>
            <div className="card-footer d-flex">
              <button
                disabled={this.state.button ? "" : "disabled"}
                className="btn btn-primary"
                onClick={this.handleSend}
              >
                {this.state.button ? "Simpan Pemeriksaan" : "Menyimpan Data..."}
              </button>
              <button className="btn btn-danger" onClick={this.onReload}>
                Tutup
              </button>
              <div style={{ flex: 1 }}></div>
              {this.state.labs ? (
                <div className="col-4 text-right">
                  <button
                    type="button"
                    className="btn btn-success"
                    data-toggle="collapse"
                    data-target="#collapsePreview"
                    aria-expanded="false"
                    aria-controls="collapsePreview"
                  >
                    <span className="btn-inner--icon">
                      <i className="fas fa-eye"></i>
                    </span>
                    <span className="btn-inner--text"> Pratinjau</span>
                  </button>
                  <ReactToPrint
                    trigger={() => (
                      <a href="#">
                        <button className="btn btn-success" type="button">
                          <span className="btn-inner--icon">
                            <i className="fa fa-print"></i>
                          </span>
                          <span className="btn-inner--text"> Cetak</span>
                        </button>
                      </a>
                    )}
                    copyStyles={false}
                    content={() => this.componentRef}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="col-12">
          <div
            style={{ width: "100%" }}
            className="accordion"
            id="accordionLog"
          >
            <div className="card">
              <div
                className="card-header"
                id={"heading"}
                data-toggle="collapse"
                data-target={"#collapse"}
                aria-expanded="false"
                aria-controls={"collapse"}
              >
                <div
                  style={{ color: color }}
                  className="h3 checklist-title mb-0"
                >
                  Log Perubahan Data Pemeriksaan Laboratorium
                </div>
              </div>
              <div
                id={"collapse"}
                className="collapse"
                aria-labelledby={"heading"}
                data-parent="#accordionLog"
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <ul className="list-group">{log}</ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalDetail
          show={this.state.showModalDetail}
          onHide={() =>
            this.setState({ showModalDetail: false, labDetail: null })
          }
          lab={this.state.labDetail}
          patient_id={this.props.detilPx.patients.id}
        />
      </div>
    );
  }
}
